// extracted by mini-css-extract-plugin
export default {"home__form":"Logo_home__form__nntEH","home__header":"Logo_home__header__AFnTd","home__button":"Logo_home__button__b1UQA"};